<template>
  <v-snackbar
      v-model="show"
      bottom
      right
      timeout="3000"
  >
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
          color="red"
          icon
          v-bind="attrs"
          :small="$vuetify.breakpoint.mobile"
          @click="show = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {getSnackbarMessage} from '@/composables/context'

export default {
  name: 'Snackbar',
  computed: {
    message: getSnackbarMessage
  },
  data () {
    return {
      show: false
    }
  },
  watch: {
    message (val) {
      this.show = !!val
    }
  }
}
</script>

<style scoped>

</style>